export const productName = 'METEOROLOGY & ATMOSPHERIC SCIENCE TEACHER READY';
export const productShortName = 'METEOROLOGY & ATMOSPHERIC SCIENCE TEACHER READY';
export const productImage = 'https://cdn.magicpatterns.com/uploads/8XX8CNGhpGJEFKRMSWf5z3/MOCKUP_12.13.22_a._m..png';

export const checkoutUrl = 'https://meteorology-atmospheric-science.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 9;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70.00';

export const included = [
  'Volume 1 — Fundamentals of Meteorology & Atmospheric Science',
  'Volume 2 — Atmospheric Energy, Temperature & Thermodynamics',
  'Volume 3 — Clouds, Precipitation & Atmospheric Moisture',
  'Volume 4 — Atmospheric Circulation, Air Masses & Weather Systems',
  'Volume 5 — Severe Weather & Extreme Atmospheric Events',
  'Volume 6 — Meteorological Observation, Instruments & Weather Data',
  'Volume 7 — Weather Analysis & Forecasting',
  'Volume 8 — Climate, Climate Variability & Global Atmospheric Processes',
  'Volume 9 — Teaching Meteorology & Atmospheric Science',
  'Bonus 1 — 150 Classroom Activities',
  'Bonus 2 — Complete Assessment Toolkit',
  'Bonus 3 — 100 Weather & Atmospheric Case Studies',
  'Bonus 4 — 100 Experiments, Investigations & Challenges',
  'Bonus 5 — Lesson Planning & Teaching Resource Library',
  '7-day money-back guarantee',
  'Instant access',
];

export const systemNegatives = [
  "It's not outdated theory copied from old textbooks.",
  "It's not a collection of disconnected activities.",
  "It's not material you'll need to completely rewrite.",
];

export const closingLines = [
  'No more sleepless nights searching for ways to explain complex atmospheric processes',
  "No more rushed lessons with materials that don't work",
  "No more disconnected students who don't see meteorology's relevance",
  'No more weekends spent building lesson plans from scratch',
  "No more awkward silences when students ask technical questions you weren't ready for",
];
